import {
  BrowseSkeletonHeader,
  BrowseSkeletonRows,
} from '@/features/raw-footage/components/browseSkeleton';
import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Pending placeholder for the organization-projects route. Mirrors
 * `OrganizationProjectsView` — org header, a "Projects" sub-head, and a list of
 * bordered project rows.
 */
export function OrganizationProjectsSkeleton() {
  return (
    <section className="space-y-4">
      <BrowseSkeletonHeader />
      <Skeleton className="h-6 w-24" />
      <BrowseSkeletonRows count={4} />
    </section>
  );
}
